import React from 'react';

const DisCard = ({ 
  children, 
  className = '', 
  hover = false,
  padding = 'md',
  ...props 
}) => {
  const paddingClasses = {
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const hoverClasses = hover ? 'hover:shadow-lg transform hover:-translate-y-1' : '';

  return (
    <div 
      className={`
        bg-white rounded-xl shadow-md transition-all duration-200 border border-gray-100
        ${paddingClasses[padding]} ${hoverClasses} ${className}
      `}
      {...props}
    >
      {children}
    </div>
  );
};

export default DisCard;